import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

import { HisAuthService, HisSearchResultRow, HisNavigationService } from 'hisng';

import { OPEN_ACCESS, NONE_QUALIFICATION_THESIS, PUBLICATION_CREATOR_TYPE_EDITORS } from 'app/fs/res/publication/model/constants';
import { PublicationModuleOptions } from '../../../publication-module.options';


@Component( {
    selector: 'res-publication-search-result-list-element',
    templateUrl: './publication-search-result-list-element.component.html'
} )
export class PublicationSearchResultListElementComponent {

    public readonly moduleOptions = PublicationModuleOptions;

    @Input() pub: HisSearchResultRow;

    // Action buttons
    @Input() showViewButton = true;
    @Input() showEditButton = true;
    @Input() showDeleteButton = true;
    @Input() prevPage: string;
    @Input() isDuplicate = false;

    // spezielle Action-Buttons, die vor dem Delete-Button eingefügt werden (z.B. Duplikate ansehen)
    @Input() customActionButtonsTemplate: TemplateRef<any>;

    // Wenn true, dann werden edit- und delete-Actionbuttons bei fehlenden canEdit-, canDelete-Flags disabled
    @Input() disableActionButtons: boolean;

    @Output() delete = new EventEmitter<HisSearchResultRow>();

    public showAllCreators = false;

    constructor( public auth: HisAuthService, private navigationService: HisNavigationService ) { }

    isQualificationThesis() {
        let qualificationThesisTypeHiskeyId: number = this.pub.get('Publication.qualificationThesis.hiskeyId');
        // console.log( 'isQualificationThesis: qualificationThesisTypeHiskeyId =', qualificationThesisTypeHiskeyId );
        return qualificationThesisTypeHiskeyId && qualificationThesisTypeHiskeyId !== NONE_QUALIFICATION_THESIS;
    }

    isPublicationPeerReviewed() {
        let peerReviewed: boolean = this.pub.get('Publication.peerReviewed');
        // console.log( 'isPublicationPeerReviewed: peerReviewed =', peerReviewed );
        return peerReviewed === true;
    }

    isOpenAccess() {
        let accessTypeHiskeyId: number = this.pub.get('Publication.access.hiskeyId');
        // console.log( 'isOpenAccess: accessTypeHiskeyId =', accessTypeHiskeyId );
        return accessTypeHiskeyId && accessTypeHiskeyId === OPEN_ACCESS;
    }

    isCreatorTypeEditor(): boolean {
        let publicationCreatorTypeHiskeyId: number = this.pub.get('Publication.publicationCreatorType.hiskeyId');
        // console.log( 'isPublicationOrganisation: publicationCreatorTypeHiskeyId =', publicationCreatorTypeHiskeyId );
        return publicationCreatorTypeHiskeyId && PUBLICATION_CREATOR_TYPE_EDITORS.indexOf( publicationCreatorTypeHiskeyId ) >= 0;
    }

    /**
     * @return the number of creators of the publication at the given index
     */
    getNumberOfCreators(): number {
        let creatorNamesList: string[] = this.pub.get('creatorNamesList');
        return creatorNamesList ? creatorNamesList.length : 0; // robustness
    }

    /**
     * Set the expansion state of the creators list of this publication to 'newValue'.
     *
     * @param newValue boolean
     */
    setShowAllCreators( newValue: boolean ) {
        this.showAllCreators = newValue;
    }

    /**
     * @return all creators of this publication
     */
    getAllCreatorNames() {
        return this.pub.get('creatorNamesStr');
    }

    /**
     * @return the first three creator names of this publication
     */
    getFirstCreatorNames(): string {
        let creatorNamesList: string[] = this.pub.get('creatorNamesList');
        return `${creatorNamesList[0]}, ${creatorNamesList[1]}, ${creatorNamesList[2]} et al.`;
    }

    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
    }

    getViewlinkQueryParams() {
        return {
            showBackButton: false,
            showSearchButton: !this.prevPage || this.prevPage === 'pubSearch',
            isDuplicate: this.isDuplicate,
            prevPage: this.prevPage
        };
    }

    getEditlinkQueryParams() {
        return {
            showBackButton: false,
            showSearchButton: !this.prevPage || this.prevPage === 'pubSearch',
            showDeleteButton: false,
            isDuplicate: this.isDuplicate,
            prevPage: this.prevPage
        };
    }

    doDelete() {
        this.delete.emit( this.pub );
    }
}
